import React, { Component } from 'react';
import Chip                 from 'material-ui/Chip';
import { tags }             from '../css/Styles';
import './../css/App.css';

class Tags extends Component
{
    handleTagTap = (tag) => {
        this.props.goToFilter(tag);
    };

    render = () => {
        let html = null;
        if (0 < this.props.tags.length)
        {
            var tagsHtml = this.props.tags.map((tag) => {
                return (<Chip className="tap-event" onTouchTap={ this.handleTagTap.bind(this, tag) } key={ tag } style={ tags.chip }>{ tag }</Chip>)
            });

            html = (<div style={ tags.wrapper }>{ tagsHtml }</div>)
        }

        return html;
    };

}

export default Tags;


// WEBPACK FOOTER //
// ./src/components/Tags.js